import React, { ReactNode, ComponentProps } from 'react'
import { styled } from 'dripsy'
import { Pressable, PressableStateCallbackType, ViewStyle } from 'react-native'

type PressableProps = React.ComponentProps<typeof Pressable>
type CallbackWithHovered = PressableStateCallbackType & { hovered?: boolean }
const StyledPressable = styled(Pressable)({})

type Props = {
  style?: ((prop: CallbackWithHovered) => ViewStyle) | ViewStyle
  children?: ReactNode | ((prop: CallbackWithHovered) => ReactNode)
} & Omit<ComponentProps<typeof StyledPressable>, 'children' | 'style'>

export default React.forwardRef(function Press(
  { sx = {}, ...props }: Props,
  ref: ComponentProps<typeof StyledPressable>['ref']
) {
  return (
    <StyledPressable
      {...(props as PressableProps)}
      ref={ref}
      sx={{ cursor: props.onPress ? 'pointer' : 'default', ...sx }}
    />
  )
})
